import React, { useState } from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { generateRecaptchaToken } from "../lib/recaptcha";
import { ThankYouModal } from "../components/ThankYouModal";

export default function EarlyAccessPage() {
  const [form, setForm] = useState({ name: "", email: "", firm: "" });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.firm) {
      setError("All fields are required.");
      return;
    }
    setSubmitting(true);
    setError("");
    try {
      let recaptchaToken = "";
      try { recaptchaToken = await generateRecaptchaToken("book_demo_page"); } catch {}
      const res = await fetch("/api/templasure/book-demo/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: form.name, email: form.email, firm: form.firm, source: "book_demo_page", recaptchaToken }),
      });
      if (!res.ok) {
        const d = await res.json().catch(() => ({}));
        throw new Error(d.error || "Submission failed");
      }
      setShowThankYou(true);
      setForm({ name: "", email: "", firm: "" });
    } catch (err: any) {
      setError(err.message || "Something went wrong.");
    } finally {
      setSubmitting(false);
    }
  };

  const inputClass =
    "w-full rounded-xl border border-[#1A4035] bg-[#0F3328] text-white placeholder:text-[#9ABFB5] px-4 py-3 focus:outline-none focus:border-[#2EB39A] focus:ring-1 focus:ring-[#2EB39A] transition-colors";

  return (
    <div className="min-h-screen font-sans" style={{ backgroundColor: "#0D2B22", color: "#FFFFFF" }}>
      <Navbar />
      <main className="flex items-center justify-center py-20 px-4">
        <div className="w-full max-w-lg">
          <div
            className="rounded-2xl border border-[#1A4035] p-10"
            style={{ backgroundColor: "#0F3328" }}
          >
            <div className="mb-8">
              <div className="mb-3">
                <span
                  className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-widest text-[#2EB39A]"
                  style={{ backgroundColor: "rgba(46,179,154,0.12)", border: "1px solid rgba(46,179,154,0.3)" }}
                >
                  Book a Demo
                </span>
              </div>
              <h1 className="text-3xl font-bold text-white mb-3">
                See Revisr in your practice context.
              </h1>
              <p className="text-[#9ABFB5]">
                A 30-minute call. No commitments. We'll show you how Revisr works for your team.
              </p>
            </div>
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="mb-1 block text-sm text-[#9ABFB5]">Full name</label>
                <input
                  type="text"
                  placeholder="Jordan Okafor"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  className={inputClass}
                />
              </div>
              <div>
                <label className="mb-1 block text-sm text-[#9ABFB5]">Work email</label>
                <input
                  type="email"
                  placeholder="you@practice.com.au"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  className={inputClass}
                />
              </div>
              <div>
                <label className="mb-1 block text-sm text-[#9ABFB5]">Practice / firm</label>
                <input
                  type="text"
                  placeholder="How many clients do you manage?"
                  value={form.firm}
                  onChange={(e) => setForm({ ...form, firm: e.target.value })}
                  className={inputClass}
                />
              </div>
              {error && <p className="text-sm text-red-400">{error}</p>}
              <button
                type="submit"
                disabled={submitting}
                className="w-full rounded-xl bg-[#2EB39A] py-3 font-bold text-[#0D2B22] transition-colors hover:bg-[#25927E] disabled:opacity-50"
              >
                {submitting ? "Sending…" : "Request my demo"}
              </button>
            </form>
          </div>
        </div>
      </main>
      <Footer />
      <ThankYouModal
        isOpen={showThankYou}
        onClose={() => setShowThankYou(false)}
        title="Demo request received!"
        message="We'll be in touch within 1 business day to confirm your session."
      />
    </div>
  );
}
